/**
 * Dernière organisation sélectionnée dans « Mes organisations ».
 * Persistance navigateur + complément du paramètre URL `?org=`.
 */

const STORAGE_KEY = 'ttr_last_managed_org_id'

export function readLastManagedOrgId(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const id = parseInt(raw, 10)
    return Number.isFinite(id) && id > 0 ? id : null
  } catch {
    return null
  }
}

export function writeLastManagedOrgId(id: number): void {
  if (!Number.isFinite(id) || id <= 0) return
  try {
    localStorage.setItem(STORAGE_KEY, String(id))
  } catch {
    /* quota / mode privé */
  }
}

export function profileMesOrganisationsUrl(orgId?: number | null): string {
  const params = new URLSearchParams({ tab: 'mes-organisations' })
  if (orgId != null && Number.isFinite(orgId) && orgId > 0) {
    params.set('org', String(orgId))
  }
  return `/profile?${params.toString()}`
}
